import { ApiReturnAlerts } from '@highimpact-frontend/api-types';
import { api_dataprocessors } from '../../../api-commons';
import { IAlertService } from './IAlertService';

class AlertService implements IAlertService {
  private readonly client;

  constructor(client = api_dataprocessors) {
    this.client = client;
  }

  async getAll(projectId: number, siteId: number, limit?: number, offset?: number): Promise<ApiReturnAlerts> {
    const url = `/projects/${projectId}/sites/${siteId}/alerts`;
    const response = await this.client.get<ApiReturnAlerts>(url, {
      params: {
        limit,
        offset,
      },
    });
    return response.data;
  }
}

const AlertServiceInstance = new AlertService();

export default AlertServiceInstance;
